import React from "react";
import { Sun, Moon } from "lucide-react";
import logo from "../../assets/LogoCabecalho.png";
import logoWhite from "../../assets/LogoCabecalhoBranca.png";
import ic1 from "../../assets/ic1.png";
import ic2 from "../../assets/ic2.png";

interface HeaderProps {
  isDark: boolean;
  scrollY: number;
  onToggleTheme: () => void;
}

export const Header: React.FC<HeaderProps> = ({
  isDark,
  scrollY,
  onToggleTheme,
}) => {
  return (
    <header
      className="fixed top-0 w-full z-50 transition-all duration-500"
      style={{
        backgroundColor: isDark
          ? `rgba(0, 0, 0, ${Math.min(scrollY / 100, 0.95)})`
          : `rgba(255, 255, 255, ${Math.min(scrollY / 100, 0.95)})`,
        backdropFilter: scrollY > 50 ? "blur(20px)" : "blur(10px)",
        borderBottom:
          scrollY > 50
            ? `1px solid ${isDark ? "rgba(255,255,255,0.1)" : "rgba(0,0,0,0.1)"}`
            : "1px solid transparent",
        boxShadow: scrollY > 50 ? "0 4px 30px rgba(0, 0, 0, 0.1)" : "none",
      }}
    >
      <div className="container mx-auto px-4 sm:px-6 py-3 sm:py-4 flex justify-between items-center max-w-7xl">
        <div className="transform transition-all duration-300 hover:scale-105 flex items-center gap-3">
          <img
            src={isDark ? ic1 : ic2}
            alt="Easyfit ícone"
            className="h-10 w-10 sm:hidden"
          />
          <img
            src={isDark ? logoWhite : logo}
            alt="Easyfit Logo"
            className="h-9 sm:h-11 hidden sm:block"
          />
        </div>
        <div className="flex items-center gap-2 sm:gap-4">
          <button
            onClick={onToggleTheme}
            className="p-2 rounded-full hover:bg-gray-100 dark:hover:bg-gray-800 transition-all duration-300 transform hover:rotate-180"
            aria-label="Toggle theme"
          >
            {isDark ? (
              <Sun className="w-5 h-5 text-yellow-400" />
            ) : (
              <Moon className="w-5 h-5 text-indigo-600" />
            )}
          </button>
          <a
            href="/login"
            className="px-4 sm:px-5 py-2 bg-gradient-to-r from-purple-600 to-purple-700 text-white text-sm font-medium rounded-full hover:from-purple-500 hover:to-purple-600 transition-all duration-300 transform hover:scale-105 hover:shadow-lg"
          >
            Login
          </a>
        </div>
      </div>
    </header>
  );
};
